import React, { useEffect, useState } from 'react'
import { fetchListItems } from '../../../../../hooks/useCrud';
import LoaderAndError from '../../../../../components/LoaderAndError';
import DOMPurify from 'dompurify';
interface UiBasic {
  id?: number;
  apropos?: string;
  travail?: string;
  don?: string;
  structuregestion?: string;
  financement?: string;
  carriere?: string;
  partenariat?: string;
  createdAt?: string;
  updatedAt?: string;
}


interface Site {
  id?: number;
  nom?: string;
  description?: string;
  email?: string;
  adresse?: string;
  tel1?: string;
  tel2?: string;
  tel3?: string;
  token?: string;
  about?: string;
  mission?: string;
  objectif?: string;
  politique?: string;
  condition?: string;
  logo?: string;
  logoFile?: File;
  facebook?: string;
  linkedin?: string;
  twitter?: string;
  youtube?: string;
  whatsapp?: string;
  createdAt?: string;
  updatedAt?: string;
}
export default function Work() {
  const [sites, setSites] = useState<Site[]>([]);
  const [basic, setBasic] = useState<UiBasic[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);


  const fetchListBasic = async () => {
    setLoading(true);
    try {
      const res = await fetchListItems<UiBasic>('/fetch_info_basic_data');
      setBasic(res.data);

      // console.log(res);
    } finally {
      setLoading(false);
    }

  }



  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await fetchListItems<Site>('/fetch_data_site');
      setSites(res.data);

      // console.log(res);
    } finally {
      setLoading(false);
    }

  }

  useEffect(() => {
    document.title = "Ce que nous faisons - Ouragan academy";
    fetchListBasic();
    fetchData();
  }, []);
  return (
    <div className="about-page-wrapper">
      {basic.length === 0 ? (
        <LoaderAndError
          loading={loading}
          error={error}
          onClearError={() => setError(null)}
        />
      ) : (
        basic.map((item, index) => (
          <div key={index}>
            {/* Hero Section */}
            <section className="about-hero">
              <h2 className="about-hero-title">
                <span className="text-success">Ce que nous</span> faisons
              </h2>
              <div className="about-hero-text">
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(item.travail ?? ""),
                  }}
                />
              </div>
            </section>

          </div>
        ))
      )}
    </div>

  )
}
